module.exports = __webpack_public_path__ + "img/box-garantias.40069a73.png";